import React from 'react';
import UISearchSection, { SearchData } from '@/components/shared/UISearchSection';
import { UISelectOption } from '@/components/shared/UISelect';
import './TenantsSearchSection.scss';

export interface TenantsSearchSectionProps {
  onSearch?: (searchTerm: string, status: string) => void;
  onStatusChange?: (status: string) => void;
  defaultStatus?: string;
  defaultSearchTerm?: string;
  loading?: boolean; // додаємо пропс для завантаження
}

const baseClass = 'TenantsSearchSection';

// Моковані опції статусу
const mockStatusOptions: UISelectOption[] = [
  { value: 'all', label: 'All Status' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'pending', label: 'Pending' }
];

const TenantsSearchSection: React.FC<TenantsSearchSectionProps> = ({
                                                                     onSearch = (searchTerm, status) => console.log('Search:', searchTerm, status),
                                                                     onStatusChange = (status) => console.log('Status changed:', status),
                                                                     defaultStatus = 'all',
                                                                     defaultSearchTerm = '',
                                                                     loading = false
                                                                   }) => {
  const handleSearch = (searchData: SearchData) => {
    onSearch(searchData.searchTerm, searchData.filterValue);
  };

  const handleSelectChange = (value: string) => {
    onStatusChange(value);
  };

  return (
    <UISearchSection
      selectOptions={mockStatusOptions}
      selectPlaceholder="Select Option"
      selectValue={defaultStatus}
      selectWidth="160px"
      inputPlaceholder="Search tenants..."
      inputValue={defaultSearchTerm}
      onSearch={handleSearch}
      onSelectChange={handleSelectChange}
      searchButtonText="Search"
      searchOnSelectChange={true}
      searchOnEnter={true}
      loading={loading}
      variant="wrapped"
      spacing="default"
      className={baseClass}
    />
  );
};

export default TenantsSearchSection;